


















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import WorkItemModalActions from '@/views/work-item/work-item-modal-actions.enum';
import WorkItemDefinitionType from '@/views/work-item/work-item-definition-type.enum';
import WorkItemService from '@/domain/work-item/work-item.service';
import WorkItemDetailed from '@/domain/work-item/work-item-detailed.entity';
import WorkItemPut from '@/domain/work-item/work-item-put.entity';
import WorkItemSummary from '@/domain/work-item/work-item-summary.entity';
import Pagination from '@/shared/pagination/pagination.component.vue';
import WorkItemRow from './work-item-row.component.vue';

const EXPAND_COLUMN = {
  text: '',
  value: 'expand',
  sortable: false,
  width: 36,
};

@Component({
  components: {
    Pagination,
    WorkItemRow,
  },
})
export default class WorkItemsList extends Vue {
  @Prop() items!: WorkItemSummary[];

  @Prop() projectId!: string;

  @Prop() loading!: boolean;

  @Prop() headerOptions!: any[];

  @Prop() totalWorkItems!: number;

  @Prop() pageProp!: number;

  @Prop() pageSizeProp!: number;

  @Prop({ type: Array, default: () => [] }) selectedWorkItens!: WorkItemSummary[];

  @Prop({ type: Boolean, default: false })
  allowMandalaEditClosedVsts!: boolean;

  @Prop({ type: String, default: 'No data found.' })
  noDataText!: string;

  private currentPage: number = this.pageProp;

  private pageSize: number = this.pageSizeProp;

  childrenWorkItems: WorkItemSummary[] = [];

  loadingChildren: boolean = false;

  expandedWorkItemId: string | null = null;

  expandedWorkItemStatusDone: boolean = false;

  pagination: any = {
    sortBy: 'createdDate,number',
    descending: 'true',
    rowsPerPage: this.pageSize,
    current: {
      rowsPerPage: this.pageSize,
    },
  };

  pageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.emitPaginationEvent();
  }

  pageSizeChange(pageSizeNumber: number) {
    this.pagination.current.rowsPerPage = pageSizeNumber;
    this.pageChange(1);
  }

  private get query() {
    const desc = this.pagination.descending === 'true' ? 'desc' : 'asc';
    const query = {
      page: this.currentPage - 1,
      size: this.currentPageSize,
      sort: `${this.pagination.sortBy},${desc}`,
    };
    return query;
  }

  private emitPaginationEvent() {
    this.$emit('paginationChanged', this.query);
  }

  private get currentPageSize() {
    if (!this.pagination.current) {
      return this.pagination.rowsPerPage;
    }
    return this.pagination.current.rowsPerPage;
  }

  get defaultPageSize() {
    const routerPageSize: number = Number(this.$route.query.size);
    if (!routerPageSize) {
      return 10;
    }
    this.pagination.current.rowsPerPage = routerPageSize;
    return routerPageSize;
  }

  get totalPages() {
    let pages = this.totalWorkItems / this.defaultPageSize;
    if (!Number.isInteger(pages)) {
      pages = Math.floor(pages) + 1;
    }
    return pages;
  }

  get parentActiveHeaders() {
    return [
      EXPAND_COLUMN,
      ...this.activeHeaders,
    ];
  }

  get parentHeaderOptions() {
    return [EXPAND_COLUMN, ...this.headerOptions];
  }

  get activeHeaders() {
    return this.headerOptions.filter((header: any) => header.active);
  }

  getBackgroundColor(workItem: WorkItemSummary): string {
    if (workItem.workItemType.definitionType === 'AGGREGATOR') {
      return '#FFFFFF';
    }
    return '#FDFFE8';
  }

  deleteItem(workItemId: string) {
    this.$emit('deleteWorkItem', workItemId);
  }

  closeItem(workItemId: string) {
    this.$emit('closeWorkItem', workItemId);
  }

  closeTaskItem(workItemId: string) {
    this.$emit('closeTaskWorkItem', workItemId);
  }

  addNewTaskWithAggregator(workItem: WorkItemSummary, value: boolean): void {
    this.$emit('showModalNewTaskWithAggregator', workItem, value);
  }

  viewModal(workItemId: string, action: string): void {
    const promises = [
      WorkItemService.getOneWorkItemById(this.projectId, workItemId),
      WorkItemService.getWorkItemErrors(this.projectId, workItemId),
    ];

    // @ts-ignore
    Promise.allSettled(promises).then((results: any) => {
      const workItem = action === 'UPDATE'
        ? WorkItemPut.of(results[0].value)
        : WorkItemDetailed.of(results[0].value);
      const definitionType = workItem.workItemType.definitionType === 'TASK'
        ? WorkItemDefinitionType.TASK
        : WorkItemDefinitionType.AGGREGATOR;
      if (results[1] && results[1].status === 'fulfilled') {
        workItem.error = results[1].value.data.error;
        workItem.errorId = results[1].value.data.errorId;
        workItem.eventDate = results[1].value.data.eventDate;
      }
      this.$emit('viewModal', workItem, action, definitionType);
    });
  }

  parseChild(item: any): WorkItemSummary {
    return new WorkItemSummary(item);
  }

  openViewDialog(workItemId: string): void {
    this.viewModal(workItemId, WorkItemModalActions.VIEW);
  }

  openUpdateDialog(workItemId: string): void {
    this.viewModal(workItemId, WorkItemModalActions.UPDATE);
  }

  openReactivateDialog(workItemId: string): void {
    this.viewModal(workItemId, WorkItemModalActions.REACTIVATE);
  }

  expandWorkItem(props: any): void {
    if (props.item.workItemType.definitionType !== 'AGGREGATOR') return;
    props.expanded = !props.expanded;

    if (props.expanded) {
      this.checkStatusExpanded(props);
      this.expandedWorkItemId = props.item.id;
      this.loadChildren(props.item.id);
    } else {
      this.expandedWorkItemId = null;
    }
  }

  checkStatusExpanded(props: any) {
    if (props.item.status !== 'OPEN') {
      this.expandedWorkItemStatusDone = true;
      return;
    }
    this.expandedWorkItemStatusDone = false;
  }

  loadChildren(workItemId: string) {
    this.childrenWorkItems = [];
    this.loadingChildren = true;
    WorkItemService.searchAllWorkItemsUnpaged(this.projectId, workItemId)
      .then((childrenWorkItems: WorkItemSummary[]) => {
        this.childrenWorkItems = childrenWorkItems;
        this.childrenWorkItems.forEach((it: WorkItemSummary, index: number) => {
          const isVsts = it.originSystem === 'VSTS';
          if (isVsts) {
            this.getChildrenErrorsByTitle(it, index);
            return;
          }
          this.getChildrenErrorsById(it, index);
        });
      }).finally(() => {
        this.loadingChildren = false;
        if (this.expandedWorkItemId === workItemId) {
          const expandedItem = this.items.find(item => item.id === workItemId);
          if (expandedItem) {
            expandedItem.expanded = true;
          }
        }
      });
  }

  getChildrenErrorsByTitle(workItem: WorkItemSummary, index: number) {
    WorkItemService
      .getWorkItemErrorsByTitle(this.projectId, workItem.title).then(({ data }: any) => {
        Vue.set(this.childrenWorkItems, index, {
          ...this.childrenWorkItems[index],
          error: data.error,
        });
      }).catch(() => {});
  }

  getChildrenErrorsById(workItem: WorkItemSummary, index: number) {
    WorkItemService.getWorkItemErrors(this.projectId, workItem.id).then(({ data }: any) => {
      Vue.set(this.childrenWorkItems, index, {
        ...this.childrenWorkItems[index],
        error: data.error,
      });
    }).catch(() => {});
  }

  onUpdateSelectedWorkItens(newSelected: WorkItemSummary[]) {
    this.$emit('update:selectedWorkItens', newSelected);
  }

  collapseRows() {
    const { aggregatorsList }: any = this.$refs;
    aggregatorsList.expanded = [];
  }
}
